import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    paddingTop: theme.spacing(2)
  }
}));

const SkillDialog = ({ open, onClose, onSave, loading }) => {
  const classes = useStyles();
  
  const [skillName, setSkillName] = useState('');

  const handleSubmit = () => {
    if (skillName.trim()) {
      onSave({ skillName: skillName.trim() });
      setSkillName(''); // Reset after save
    }
  };

  const handleClose = () => {
    setSkillName(''); // Reset on close
    onClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && skillName.trim()) {
      handleSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Skill</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TextField
          autoFocus
          label="Skill Name"
          placeholder="Ex: React, JavaScript, Project Management"
          fullWidth
          variant="outlined"
          value={skillName}
          onChange={(e) => setSkillName(e.target.value)}
          onKeyPress={handleKeyPress}
          helperText="Press Enter to add"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!skillName.trim() || loading}
        >
          {loading ? 'Adding...' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SkillDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

SkillDialog.defaultProps = {
  loading: false
};

export default SkillDialog;

